import React, { FC } from 'react'

import { styled } from '@mui/material';

import Button from '@mui/material/Button'
import AddIcon from '@mui/icons-material/Add';

import { useLocalizedText } from '../../context/Localization/localizationHooks';
import { LocalizedText } from '../../context/Localization/LocalizationTypes';
import { useAppDispatch } from '../../hooks/reduxHooks';
import { addGroup } from '../../store/groupConditionsSlice';
import { useViewModeReadOnly } from '../../context/ViewMode/viewModeHooks';

const RootContainer = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '24px',
}))

export const AddGroupConditionButtonContainer = styled(Button)(({ theme }) => ({
    textTransform: 'capitalize',
    fontFamily: 'Open Sans',
    padding: '12px 24px',
    '&:hover': {
        color: theme.palette.primary.contrastText,
    },
}))

export interface AddGroupConditionProps {
}

const AddGroupCondition: FC<AddGroupConditionProps> = (props) => {
    const ADD_NEW_CONDITION_GROUP = useLocalizedText(LocalizedText.AddGroupCondition)
    const isReadOnly = useViewModeReadOnly()
    const dispatch = useAppDispatch()

    return (
        <RootContainer>
            <AddGroupConditionButtonContainer disabled={isReadOnly} variant="contained" startIcon={<AddIcon />} onClick={() => dispatch(addGroup())}>
                {ADD_NEW_CONDITION_GROUP}
            </AddGroupConditionButtonContainer>
        </RootContainer>
    )
}

export default AddGroupCondition